// Enum is used because there might be another states, e.g. FORGOT_PASSWORD
enum AuthorizationFormState {
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER'
}

export enum SignInStep {
  SIGN_IN = 'SIGN_IN',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD'
}

export enum SignUpStep {
  FIRST_STEP = 'first_step',
  SECOND_STEP = 'second-step',
  THIRD_STEP = 'third-step'
}

export default AuthorizationFormState;
